import React, { Component } from "react";
import mailIcon from "../../assets/images/mail_icon.svg";

class ClipboardComponent extends Component {
  handleClick = () => {
    this.props.captureClick();
  };

  handleMouseEnter = () => {
    this.props.captureMouseEnter();
  };

  handleMouseLeave = () => {
    this.props.captureMouseLeave();
  };

  render() {
    const { clipboard, copytext } = this.props;
    return (
      <div onClick={this.handleClick} className={`clipboard ${clipboard ? "clipboard-hover" : ""}`} onMouseEnter={this.handleMouseEnter} onMouseLeave={this.handleMouseLeave}>
        <img src={mailIcon} alt="write a mail" />
        <p>mail@sathish.dev</p>
        {clipboard && <h6>{copytext}</h6>}
      </div>
    );
  }
}

export default ClipboardComponent;
